/**
 * mwApp.partnerPrograms module <br>
 * Work with partnerPrograms: show/add/edit/remove
 *
 * @namespace mwApp/devices
 */

import devicesConfig from './partnerPrograms.config'
import PartnerProgramsCtrl from './partnerPrograms.controller'
import AddPartnerProgramCtrl from './addPartnerProgram.controller'

export default
angular.module('mwApp.partnerPrograms', [])
  .config(devicesConfig)
  .controller('PartnerProgramsCtrl', PartnerProgramsCtrl)
  .controller('AddPartnerProgramCtrl', AddPartnerProgramCtrl)
